import { useState, useCallback, useEffect, useMemo } from "react"

import { Guid } from "@/types"
import AssetDisplayStatus from "models/AssetDisplayStatus"
import AssetService from "services/AssetService"

export default function useAssetDisplayStatuses(_assetIds: Guid | Guid[], onFail?: (e) => void) {
    const assetIds = useMemo(() => _assetIds instanceof Array ? _assetIds : [_assetIds], [_assetIds])
    const [displayStatuses, setDisplayStatuses] = useState<{ [assetId: string]: AssetDisplayStatus } | null>(null)
    const [isLoading, setIsLoading] = useState(true)

    const fetchAssetDisplayStatus = useCallback(async (ids: Guid[]) => {
        if (!ids || !ids.length) return
        try {
            setIsLoading(true)
            const newDisplayStatuses = await AssetService.getAssetDisplayStatuses(ids)
            setDisplayStatuses(newDisplayStatuses)
            setIsLoading(false)
        } catch (e) {
            onFail?.(e)
        }
    }, [onFail])

    useEffect(() => {
        if (!assetIds.length) return
        fetchAssetDisplayStatus(assetIds)
    }, [fetchAssetDisplayStatus, assetIds])

    return {
        loading: isLoading,
        displayStatuses,
    }

}
